export enum CookieConsent {
  Accepted = 'accepted',
  Rejected = 'rejected',
  Ask = 'ask',
}
